<template>
  <div class="animated fadeInRight ecommerce">
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('servAppraiseManage.queryTitle') }}</span>
          </div>
          <el-form :inline="true" :model="servAppraiseManageInfo.conditions" class="flex justify-start">
            <el-form-item>
              <el-input v-model="servAppraiseManageInfo.conditions.servName"
                :placeholder="$t('servAppraiseManage.servNamePlaceholder')" clearable />
            </el-form-item>
            <el-form-item>
              <el-input v-model="servAppraiseManageInfo.conditions.appraiseUserName"
                :placeholder="$t('servAppraiseManage.userPlaceholder')" clearable />
            </el-form-item>
            <el-form-item>
              <el-input v-model="servAppraiseManageInfo.conditions.servId"
                :placeholder="$t('servAppraiseManage.servIdPlaceholder')" clearable />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="_queryOrdersMethod">
                <i class="el-icon-search"></i> {{ $t('servAppraiseManage.queryBtn') }}
              </el-button>
              <el-button type="primary" size="small" @click="_resetOrdersMethod">
                <i class="el-icon-refresh"></i> {{ $t('servAppraiseManage.resetBtn') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('servAppraiseManage.tableTitle') }}</span>
          </div>
          <serv-appraise-manage-table :appraises="servAppraiseManageInfo.appraises" @ack-appraise="_ackAppraise" />
          <el-pagination background layout="total, sizes, prev, pager, next, jumper"
            :total="servAppraiseManageInfo.total" :page-size="servAppraiseManageInfo.conditions.row"
            :current-page="servAppraiseManageInfo.conditions.page" @current-change="handleCurrentChange"
            @size-change="handleSizeChange" />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryShopAppraise } from '@/api/housekeeping/servAppraiseManage/servAppraiseManageApi'
import ServAppraiseManageTable from '@/components/housekeeping/servAppraiseManage/servAppraiseManageTable'

export default {
  name: 'ServAppraiseManage',
  components: {
    ServAppraiseManageTable
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      servAppraiseManageInfo: {
        appraises: [],
        total: 0,
        conditions: {
          servName: '',
          servId: '',
          appraiseUserName: '',
          shopId: '',
          objType: '2002',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.servAppraiseManageInfo.conditions.shopId = getShopId()
    this._listServAppraises(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {
    _listServAppraises(_page, _rows) {
      this.servAppraiseManageInfo.conditions.page = _page
      this.servAppraiseManageInfo.conditions.row = _rows
      const param = {
        params: this.servAppraiseManageInfo.conditions
      }
      param.params.servName = param.params.servName.trim()
      param.params.appraiseUserName = param.params.appraiseUserName.trim()
      param.params.servId = param.params.servId.trim()

      queryShopAppraise(param.params)
        .then(response => {
          this.servAppraiseManageInfo.total = response.total
          this.servAppraiseManageInfo.records = response.records
          this.servAppraiseManageInfo.appraises = response.data
        })
        .catch(error => {
          console.log('请求失败处理', error)
        })
    },
    _queryOrdersMethod() {
      this._listServAppraises(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _resetOrdersMethod() {
      this.servAppraiseManageInfo.conditions.servName = ''
      this.servAppraiseManageInfo.conditions.appraiseUserName = ''
      this.servAppraiseManageInfo.conditions.servId = ''
      this._listServAppraises(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _ackAppraise(appraise) {
      console.log(appraise)
    },
    handleCurrentChange(val) {
      this._listServAppraises(val, this.servAppraiseManageInfo.conditions.row)
    },
    handleSizeChange(val) {
      this._listServAppraises(this.servAppraiseManageInfo.conditions.page, val)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.el-row {
  width: 100%;
}

.el-col {
  width: 100%;
}
</style>